// components
import { SelectField } from 'ht-styleguide';

/* Styles */
import styles from '../prequestioncheckbox.module.scss';

/* types */
import { Answer } from 'types/sku.types';

type QTYSelectorValue = {
  id: number;
  quantity?: number;
};

const QTY_OPTIONS = [...'x'.repeat(26)].map((_, i) => {
  const value = 1 + i;
  return { value, label: value };
});

type CheckboxQuantitySelectorProps = {
  selectedValue?: QTYSelectorValue;
  answer?: Answer;
  onChange: BaseAnyFunction;
};

const CheckboxQuantitySelector = ({ selectedValue, answer, onChange }: CheckboxQuantitySelectorProps) => {
  const value = selectedValue ? selectedValue.quantity || 1 : 1;
  return (
    <div className={styles.quantityWrapper}>
      <SelectField
        className={styles.quantity}
        options={QTY_OPTIONS}
        value={value}
        label="QTY"
        clearable={false}
        searchable={false}
        onChange={({ value: newValue }) => onChange(answer, newValue)}
      />
    </div>
  );
};

export default CheckboxQuantitySelector;
